import React from "react";
import CartubeLogo from "../assets/icons/cartube-logo.png";

function LoadingScreen() {
  return (
    <div
      style={{
        backgroundColor: "#fff",
        display: "flex",
        justifyContent: "center",
        height: "100vh",
        alignItems: "center",
      }}
    >
      <img src={CartubeLogo} width="80%" alt="wheelpal-android" />
    </div>
  );
}

export default LoadingScreen;
